import ManageBusinessTypes from "./manage-types";

const BusinessTypes = () => {
  return (
    <>
      <ManageBusinessTypes />
    </>
  );
};
export default BusinessTypes;
